import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { Tracking  } from '@providers/asset/index';
import { LocationPage } from '../location/page';


@Component({
  selector: 'page-activity',
  templateUrl: 'page.html'
})
export class ActivityPage {

  data:any={
    id:'',
    tracking_name :'',
    status:'0',
    date_time:''
  };

  constructor(
    public navCtrl: NavController,
    public trackingApi: Tracking,
    public toastCtrl: ToastController,
    public barcodeScanner:BarcodeScanner,
    public loadingCtrl: LoadingController
  ) {

  }

  ionViewDidEnter() {
    this.get();
  }

  get(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params:any = { status:0 };
    this.trackingApi.get(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.data = resp.data[0];
        this.trackingApi.active=1;
        this.trackingApi.data=resp.data[0];
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  post(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = this.data;
    this.trackingApi.post(params).subscribe((resp:any) => {
      if(resp.data.length>0){
        this.data = resp.data[0];
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  scan(){
    this.barcodeScanner.scan().then(barcodeData => {
      if(barcodeData.text!=''){
        let params = { tracking:1 };
        this.navCtrl.push(LocationPage,params);
      }
     }).catch(err => {
         console.log('Error', err);
     });
  }

  track(e){
    if(e.toElement.className=='button-inner'){
      return;
    }
    let params = { tracking:1 };
    this.navCtrl.push(LocationPage,params);
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/activity/page.ts